import React, { useState, useRef, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { QRCodeCanvas } from "qrcode.react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { FaFilePdf, FaSync, FaTrash, FaArrowRight, FaStar, FaExclamationCircle, FaLightbulb } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";

export default function GenerateUIDPage() {
    const navigate = useNavigate();
    const location = useLocation(); // لاستقبال الـ UID الممرر

    const [count, setCount] = useState(2);
    const [generatedData, setGeneratedData] = useState([]);
    const [isExporting, setIsExporting] = useState(false);
    const reportRef = useRef();

    const baseUrl = "https://custpro.org/";

    // التأكد مما إذا كان هناك UID ممرر عبر الـ state أو الرابط
    useEffect(() => {
        // نبحث عن UID في الـ state (لو أرسلته عبر navigate) 
        // أو كـ Query Parameter (لو أردت ذلك)
        const params = new URLSearchParams(location.search);
        const passedUid = params.get("uid") || location.state?.uid;

        if (passedUid) {
            // إذا وجدنا UID، نقوم بتوليد كرت واحد له فقط
            setGeneratedData([{ id: passedUid, url: `${baseUrl}${passedUid}` }]);
            setCount(1);
        }
    }, [location]);

    const handleGenerate = () => {
        const newData = [];
        for (let i = 0; i < count; i++) {
            const uid = uuidv4();
            newData.push({ id: uid, url: `${baseUrl}${uid}` });
        }
        setGeneratedData(newData);
    };
    const exportPDF = async () => {
        setIsExporting(true);
        const pdf = new jsPDF("p", "mm", "a4");
        const pages = reportRef.current.querySelectorAll(".print-page");

        for (let i = 0; i < pages.length; i++) {
            const canvas = await html2canvas(pages[i], {
                scale: 1.5, // تقليل الدقة قليلاً لموازنة الحجم والجودة
                useCORS: true,
                logging: false
            });

            // تحويل إلى JPEG مع ضغط 70% (يقلل الحجم بشكل مذهل)
            const imgData = canvas.toDataURL("image/jpeg", 0.7);

            if (i > 0) pdf.addPage();
            pdf.addImage(imgData, "JPEG", 0, 0, 210, 297);
        }

        pdf.save("Custpro_Cards.pdf");
        setIsExporting(false);
    };
    const exportPDF1 = async () => {
        setIsExporting(true);
        const pdf = new jsPDF("p", "mm", "a4");
        const pages = reportRef.current.querySelectorAll(".print-page");

        for (let i = 0; i < pages.length; i++) {
            const canvas = await html2canvas(pages[i], {
                scale: 2,
                useCORS: true,
                logging: false
            });
            const imgData = canvas.toDataURL("image/png");
            if (i > 0) pdf.addPage();
            pdf.addImage(imgData, "PNG", 0, 0, 210, 297);
        }

        const fileName = generatedData.length === 1 ? `QR_Specific_${generatedData[0].id.substring(0, 8)}.pdf` : "Custpro_Bulk_Cards.pdf";
        pdf.save(fileName);
        setIsExporting(false);
    };

    return (
        <div className="bg-light min-vh-100 py-4" dir="rtl">
            {/* واجهة التحكم */}
            <div className="container shadow-sm bg-white rounded-4 p-4 d-print-none mb-5">
                <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
                    <div>
                        <h3 className="fw-bold text-dark mb-1">منصة التقييم الذكي</h3>
                        <p className="text-muted small mb-0">توليد البطاقات الفردية والجماعية</p>
                    </div>
                    <div className="d-flex gap-2">
                        <button onClick={exportPDF} className="btn btn-danger rounded-pill px-4" disabled={generatedData.length === 0 || isExporting}>
                            {isExporting ? "جاري الحفظ..." : <><FaFilePdf className="ms-2" /> تصدير PDF</>}
                        </button>
                        <button onClick={() => navigate(-1)} className="btn btn-outline-secondary rounded-pill">
                            <FaArrowRight className="ms-1" /> رجوع
                        </button>
                    </div>
                </div>

                <div className="row g-3 align-items-end">
                    <div className="col-md-4">
                        <label className="form-label fw-bold small">عدد النسخ العشوائية</label>
                        <input type="number" className="form-control rounded-3" value={count} onChange={(e) => setCount(Number(e.target.value))} />
                    </div>
                    <div className="col-md-4">
                        <button onClick={handleGenerate} className="btn btn-primary w-100 rounded-3"><FaSync className="ms-2" /> توليد عشوائي جديد</button>
                    </div>
                    <div className="col-md-4">
                        <button onClick={() => setGeneratedData([])} className="btn btn-outline-danger w-100 rounded-3"><FaTrash className="ms-2" /> تفريغ القائمة</button>
                    </div>
                </div>

                {/* تنبيه بسيط في حال كان الوضع "فردي" */}
                {location.state?.uid && (
                    <div className="alert alert-info mt-3 py-2 small shadow-sm">
                        يتم الآن عرض البطاقة الخاصة بالـ UID الممرر: <strong>{location.state.uid}</strong>
                    </div>
                )}
            </div>

            {/* منطقة المعاينة والطباعة */}
            <div ref={reportRef} style={{ background: "#f0f0f0", padding: "20px 0" }}>
                {Array.from({ length: Math.ceil(generatedData.length / 2) }).map((_, pageIndex) => (
                    <div key={pageIndex} className="print-page" style={pageContainerStyle}>
                        {generatedData.slice(pageIndex * 2, pageIndex * 2 + 2).map((item, idx) => (
                            <div key={idx} style={cardStyle}>
                                <div style={innerContainer}>

                                    {/* جهة اليمين: النصوص */}
                                    <div style={rightSide}>
                                        <h1 style={titleStyle}>حماية المستهلك وسلامة الغذاء</h1>
                                        <p style={descStyle}>ساهم معنا في رفع جودة الخدمة من خلال مسح الرمز ومن ثم :  </p>

                                        <div style={listStyle}>
                                            <div style={listItem}><FaStar color="#f59e0b" size={20} /> <span>تقييم مستوى الخدمة</span></div>
                                            <div style={listItem}><FaLightbulb color="#3b82f6" size={20} /> <span>مشاركتنا مقترحاتك</span></div>
                                            <div style={listItem}><FaExclamationCircle color="#ef4444" size={20} /> <span>تقديم شكوى مباشرة</span></div>
                                        </div>

                                        <div style={{ marginTop: '25px', fontSize: '18px', color: '#3112a1ff' }}>
                                            وفي حال تعذر مسح الرمز يمكنك الذهاب ل       : custpro.org
                                        </div>
                                    </div>

                                    {/* جهة اليسار: الـ QR */}
                                    <div style={leftSide}>
                                        <div style={qrBox}>
                                            <QRCodeCanvas value={item.url} size={180} level={"H"} />
                                            <p style={{ marginTop: '10px', fontSize: '12px', fontWeight: 'bold', color: '#555' }}>امسح هنا (SCAN)</p>
                                        </div>
                                    </div>

                                </div>
                                {idx === 0 && <div style={cutDashedLine}></div>}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}

// --- التنسيقات (تبقيها كما هي في الكود الأصلي) ---
const pageContainerStyle = { width: "210mm", height: "297mm", backgroundColor: "#fff", margin: "0 auto 30px auto", display: "flex", flexDirection: "column", position: "relative", direction: "rtl" };
const cardStyle = { height: "148.5mm", width: "100%", padding: "15mm 10mm", display: "flex", alignItems: "center", justifyContent: "center", position: "relative" };
const innerContainer = { width: "100%", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", border: "2px solid #222", borderRadius: "15px", padding: "25px", height: "100%" };
const rightSide = { flex: "0 0 65%", textAlign: "right", display: "flex", flexDirection: "column", justifyContent: "center" };
const leftSide = { flex: "0 0 35%", display: "flex", justifyContent: "center", alignItems: "center" };
const titleStyle = { fontSize: "38px", fontWeight: "900", color: "#000", margin: "0 0 10px 0", lineHeight: "1.2" };
const descStyle = { fontSize: "20px", color: "#444", lineHeight: "1.4", marginBottom: "25px" };
const listStyle = { display: "flex", flexDirection: "column", gap: "12px" };
const listItem = { display: "flex", alignItems: "center", gap: "10px", fontSize: "20px", fontWeight: "bold", color: "#333" };
const qrBox = { padding: "15px", backgroundColor: "#fff", border: "1px solid #ddd", borderRadius: "12px", textAlign: "center" };
const cutDashedLine = { position: "absolute", bottom: "0", left: "5%", right: "5%", borderBottom: "1px dashed #bbb" };